import type { AppState } from "metabase/redux/store";

export const createMockAppState = (opts?: Partial<AppState>): AppState => ({
  detailView: null,
  isNavbarOpen: true,
  errorPage: null,
  isDndAvailable: false,
  isErrorDiagnosticsOpen: false,
  tempStorage: {
    "last-opened-onboarding-checklist-item": undefined,
    "pending-login-credentials": undefined,
  },
  ...opts,
});
